import {CashPaymentResponse} from '../../../pages/shopping-basket/cash-payment/utils/types';
import request from '../../axios';

export const getOrderCashTransactionPrice = async (orderGuid?: string) => {
  const {data}: {data: CashPaymentResponse} = await request.get(
    `/api/v2/payment/order-cash-transaction-price`,
    {
      params: {order: orderGuid},
    },
  );

  return data;
};
